import { render, staticRenderFns } from "./RoutesCard.vue?vue&type=template&id=a653e520&"
import script from "./RoutesCard.vue?vue&type=script&lang=js&"
export * from "./RoutesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports